import {
    MissionGroupColor,
    missionGroupColors,
    MissionGroupIcon as TMissionGroupIcon,
    missionGroupIcons,
} from "@nova/schemas"
import { Dispatch, SetStateAction } from "react"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { MissionGroupIcon } from "./MissionGroupIcon"

export const MissionGroupsAppearanceSelector = ({
    selectedColor,
    setSelectedColor,
    selectedIcon,
    setSelectedIcon,
}: {
    selectedColor: MissionGroupColor | undefined
    setSelectedColor: Dispatch<SetStateAction<MissionGroupColor>>
    selectedIcon: TMissionGroupIcon | undefined
    setSelectedIcon: Dispatch<SetStateAction<TMissionGroupIcon>>
}) => {
    return (
        <div className="w-full rounded-lg bg-gray-700 px-4 py-3 flex flex-col gap-3">
            <div className="flex gap-3">
                {missionGroupColors.map((color) => {
                    return (
                        <div
                            key={color}
                            className="w-8 h-8 rounded-md flex items-center justify-center cursor-pointer hover:brightness-110"
                            style={{ backgroundColor: color }}
                            onClick={() => setSelectedColor(color)}
                        >
                            {selectedColor === color && (
                                <Icons.Icon Icon={Icons.Checkmark} className="text-white" />
                            )}
                        </div>
                    )
                })}
            </div>
            <div className="w-full h-px bg-white-200" />
            <div className="flex gap-3 flex-wrap">
                {missionGroupIcons.map((icon) => {
                    return (
                        <div
                            key={icon}
                            className={classNames("shrink-0 rounded-md outline cursor-pointer", {
                                "outline-[1.5px] outline-white": selectedIcon === icon,
                                "outline-1 outline-transparent hover:outline-white transition-colors":
                                    selectedIcon !== icon,
                            })}
                            onClick={() => setSelectedIcon(icon)}
                        >
                            <MissionGroupIcon
                                color={selectedColor ?? missionGroupColors[0]}
                                icon={icon}
                                size="32"
                                transition
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
